import { render, staticRenderFns } from "./EmployeePersonalData.vue?vue&type=template&id=a433cbe8&"
import script from "./EmployeePersonalData.vue?vue&type=script&lang=js&"
export * from "./EmployeePersonalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports